import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { EFirstMessageStatus } from '../../../types/firstMessageStatus';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageChatsBlocked } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, Messages, TFirstMessageResponse } from '../types';

export const assertBlockedStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.Blocked) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendChatsBlocked);

      const message = Messages[EFirstMessageStatus.ChatsBlocked];

      dispatch(setFirstMessageChatsBlocked());
      dispatch(showAlert({ message }));

      const error = new GuardError({
        message,
        domain,
      });

      logger.error(error);
    }
  };
